<div class="main main-full main-responsive">
    <app-title [title]="'Something went wrong.'"
        [subtitle]="'We are not sure what happened here, try again and if the problem persists please contact customer service.'"></app-title>
</div>